module.exports = __webpack_public_path__ + "img/step4-en.8e8a4733.webp";